// ===============================
// Sticky Add To Cart (Shopify)
// ===============================

document.addEventListener('DOMContentLoaded', () => {
  const stickyATC = document.querySelector('.shopify-sticky-atc');
  const variantBlock = document.querySelector('.product-form__input');
  const trigger = document.querySelector('[data-sticky-trigger]');

  if (!stickyATC || !trigger) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        stickyATC.classList.add('is-sticky');
        variantBlock?.classList.add('shopify-variant-margin');
      } else {
        stickyATC.classList.remove('is-sticky');
        variantBlock?.classList.remove('shopify-variant-margin');
      }
    },
    {
      root: null,
      threshold: 0
    }
  );

  observer.observe(trigger);
});








